/** 试剂无图时的默认展示图（位于 frontend/public/） */
export const DEFAULT_REAGENT_IMAGE = '/default-reagent.jpg';

/** 后端 uploads 中同名默认图，供小程序等走 /api/uploads 访问 */
export const DEFAULT_REAGENT_UPLOAD_PATH = '/uploads/default-reagent.jpg';

/** 耗材无图时的默认展示图（位于 frontend/public/） */
export const DEFAULT_CONSUMABLE_IMAGE = '/default-consumable.jpg';

/** 后端 uploads 中同名默认图，供小程序等走 /api/uploads 访问 */
export const DEFAULT_CONSUMABLE_UPLOAD_PATH = '/uploads/default-consumable.jpg';

/** 仪器设备无图时的默认展示图（位于 frontend/public/） */
export const DEFAULT_INSTRUMENT_IMAGE = '/default-instrument.jpg';

/** 后端 uploads 中同名默认图，供小程序等走 /api/uploads 访问 */
export const DEFAULT_INSTRUMENT_UPLOAD_PATH = '/uploads/default-instrument.jpg';
